export enum ServiceContractAdditionalReason {
    INSIDE_SALES = 'INSIDE_SALES',
    POC = 'POC',
    REQUEST_PM = 'REQUEST_PM',
    REQUEST_ESFR = 'REQUEST_ESFR'
}

export const bookingSubmissionAdditionalReasons = [
    ServiceContractAdditionalReason.INSIDE_SALES,
    ServiceContractAdditionalReason.POC
];

export const preventativeMaintenanceAdditionalReasons = [
    ServiceContractAdditionalReason.REQUEST_PM,
    ServiceContractAdditionalReason.REQUEST_ESFR
];
